import Vue from 'vue'
import Vuex from 'vuex'

import router from '@/config/router'
import vuetify from './plugins/vuetify' // NOTE: Only use TimeInput
import i18n from '@/config/i18n'
import store from './store'
import firebaseHelper from '@/helper/firebaseHelper'
import setTitleMixIn from '@/config/title'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration, Dedupe, Transaction } from '@sentry/integrations'

require('./style/main.scss')
import App from './App.vue'

// TODO: Add Sentry setting
Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DNS,
  beforeBreadcrumb(breadcrumb: any) {
    return breadcrumb.category === 'ui.click' ? null : breadcrumb
  },
  integrations: [
    new Dedupe(),
    new Transaction(),
    new VueIntegration({ Vue, attachProps: true, logErrors: true })
  ],
})

// NOTE: Load any modules
Vue.use(Vuex)
Vue.mixin(setTitleMixIn)
const vClickOutside = require('v-click-outside')
Vue.use(vClickOutside)

const VueIntercom = require('vue-intercom')
Vue.use(VueIntercom, {
  appId: process.env.VUE_APP_INTERCOM_APP_ID
})

Object.defineProperty(Vue.prototype, '$firebase', {
  get: () => firebaseHelper.firebaseApp
})

Vue.config.productionTip = false
Vue.use(vuetify, {
  lang: {
    t: (key:any, ...params:any[]) => i18n.t(key, params)
  }
})

Vue.filter('number', function (v: number) {
  if (v === null || typeof v !== 'number') return ''
  return v.toLocaleString()
})

new Vue({
  router,
  vuetify,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
